// Module
var code = "<div class=\"date-select-container always-top\"> <div> <div> <uc-date-picker data-ng-model=\"searchOptions.referenceDay\" data-options=\"pickerOptions\" change-date=\"changeDate(date)\" is-search-page=\"true\" is-goto-date=\"isGotoDate\" goto-date=\"gotoDate\"></uc-date-picker> </div> </div> </div> ";
// Exports
export default code;